import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Container } from 'react-bootstrap';
import Navigation from './components/Navigation';
import Accueil from './pages/Accueil';
import Agents from './pages/Agents';
import Groupes from './pages/Groupes';
import CartesPointage from './pages/CartesPointage';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// Configuration React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className="App">
          <Navigation />
          <Container fluid className="mt-3">
            <Routes>
              <Route path="/" element={<Accueil />} />
              <Route path="/agents" element={<Agents />} />
              <Route path="/groupes" element={<Groupes />} />
              <Route path="/cartes-pointage" element={<CartesPointage />} />
            </Routes>
          </Container>
        </div>
      </Router>
    </QueryClientProvider>
  );
}

export default App; 